import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IMedicationLogisticsActions, IThunkGetMedicationDeliveries } from '../types';

const onGetMedicationDeliveries: IThunkGetMedicationDeliveries = thunk(
  async ({ setMedicationDeliveries }: Actions<IMedicationLogisticsActions>, payload) => {
    const { clinicId, teamId, clientId, from, to, currentTeamDeliveriesOnly } = payload;

    const { medications, monitoredBy } = await api.medicationLogistics
      .getClientMedicationDeliveriesList(
        { clinicId, teamId },
        { clientId, from, to, currentTeamDeliveriesOnly },
      )
      .then(r => r.data);

    setMedicationDeliveries({ deliveries: medications, monitoredBy });
  },
);

export default onGetMedicationDeliveries;
